export const alertOptions: string[] = [
  'Transfers above 50 000 EUR for linked operations in 48 hours',
  'More than 4 outgoing above 15 000 EUR for 48 hours',
  'More than 3 incoming 1 sender to 1 receiver in 1 day',
  'Non FATF countries',
  'Customer country list'
];

